import { BodyText, Heading } from '@kpa/kul';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NyhetsBlockResponse } from '../../types/blocks';
import { NyhetResponse, NyhetsarkivResponse } from '../../types/pages';
import Nyhet from './Nyhet';
import styles from './NyhetslistaKompakt.module.css';

export type Nyheter = NyhetsarkivResponse | NyhetsBlockResponse;

type NyhetslistaKompaktProps = {
  nyhetslista: Nyheter;
};

const NyhetslistaKompakt: FC<NyhetslistaKompaktProps> = ({ nyhetslista }): ReactNode => {
  const [nyhetsBlock, setNyhetsBlock] = useState<Map<number, NyhetResponse[]>>(new Map<number, NyhetResponse[]>());
  const nav = useNavigate();

  useEffect(() => {
    const block = new Map<number, NyhetResponse[]>();
    nyhetslista.nyheter.forEach((nyhet) => {
      const år = new Date(nyhet.publiceringsdatum).getFullYear();
      block.set(år, [...block.get(år) ?? [], nyhet]);
    });
    setNyhetsBlock(block);
  }, [nyhetslista]);

  const redirect = (e: React.MouseEvent<HTMLAnchorElement | MouseEvent>, url: string) => {
    e.preventDefault();
    nav(url);
  };

  return (
    <div className={styles.container}>
      {nyhetslista.rubrik && <Heading className={styles.header} headingLevel={2}>{nyhetslista.rubrik}</Heading>}
      {
        [...nyhetsBlock.entries()].map(([år, nyheter]) => (
          <React.Fragment key={år}>
            <ul className={styles.ul}>
              {nyheter.length > 0 && nyheter.map(nyhet => (
                <li className={styles.li} key={nyhet.id}>
                  <Nyhet nyhet={nyhet}></Nyhet>
                </li>
              ))}
            </ul>
          </React.Fragment>
        ))
      }
      {
        ('url' in nyhetslista) && (
          <a href={nyhetslista.url} className={styles.footer} onClick={e => redirect(e, nyhetslista.url ?? '')} rel="noopener noreferrer">
            <BodyText color="darkBlue">Alla nyheter</BodyText>
          </a>
        )
      }
    </div>
  );
};

export default NyhetslistaKompakt;
